/**
 * TYT Platform API
 * This is the TYT Platform API. It is used by TYT's apps to interact 
 * with the underlying platform. 
 *
 * NOTE: This file is auto generated. 
 * Do not edit this file manually.
 */

import { BaseModel, Expand, Model, Type } from '../../common';


export interface PostUsersEmailConflictRequest {

    email?: string;

    return_url?: string;

    token?: string;

}

@Model('PostUsersEmailConflict')
export class ApiPostUsersEmailConflict extends BaseModel implements PostUsersEmailConflictRequest {

    
    
    email: string;

    
    
    return_url: string;

    
    
    token: string;

}
